import { InjectionToken } from '@angular/core';

export const WidgetSettingsToken = new InjectionToken('GoldenLayoutComponentState');
